import { effect, EventEmitter, Injector, runInInjectionContext } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { fromUnixTime, getUnixTime, isWithinInterval } from 'date-fns';
import { Fragment } from 'src/app/interfaces/api/fragment';
import { Metric } from 'src/app/interfaces/api/metric';
import { ExtendedModel } from 'src/app/interfaces/api/model';
import { PlanningTask, PutTask } from 'src/app/interfaces/api/task';
import { PlanningService } from 'src/app/services/api/plannings/planning.service';
import { PlanningStore } from 'src/app/services/stores/planning.store';
// import template from "./main";

const Autodesk = window.Autodesk;

export class PlanningDockingPanel extends Autodesk.Viewing.UI.DockingPanel {
    viewer: any;
    options: any;
    onCellEditCallback: Function | null = null;
    onDeleteCallback: Function | null = null;
    public mainContainer!: HTMLElement;
    currentFragIds: number[] = [];
    objectTree: Record<string, any> = {};
    tasks: PlanningTask[] = [];
    linkedTasks: PlanningTask[] = [];
    template: any;
    _template: any;
    isPlanningTools: boolean = false;
    objectNameText: string = '';
    objectdbId: string | number = '';
    isTaskList: boolean = false;
    taskListElem: HTMLElement | null = null;
    objectStateElem: HTMLElement | null = null;
    objectTypeElem: HTMLElement | null = null;
    objectDateElem: HTMLElement | null = null;
    objectLevelElem: HTMLElement | null = null;
    objectZoneElem: HTMLElement | null = null;
    ObjectTreeText: string = '';
    selectedFragIds: number[] = [];
    translate: TranslateService;
    planningService: PlanningService;
    currentState: string | null = null;
    fragments: Fragment[] = [];
    selectedTasks: PlanningTask[] = [];
    selectedFragments: Fragment[] = [];
    setFragColor: Function;
    onImageClick: Function;
    waitForSelection: string[] = [];
    model: ExtendedModel;
    metrics: Metric[] = [];
    selectedMetrics: Metric[] = [];
    onTaskUpdate?: EventEmitter<PlanningTask>;
    reload?: Function;
    ganttManager: any = {};
    injector!: Injector;
    planningStore: PlanningStore = {} as PlanningStore;

    public currentDate: string = '';
    currentTask: PlanningTask | null = null;
    currentFragments: Fragment[] = [];

    constructor(viewer: any, container: HTMLElement, id: string, title: string, options: any) {
        super(container, id, title, options);
        this.viewer = viewer;
        this.translate = options.translate;
        this.model = options.model;
        this.planningService = options.planningService;
        this.planningStore = options.planningStore;
        this.injector = options.injector;
        this.setFragColor = options.setFragColor;
        this.onImageClick = options.onImageClick;
        // this.template = template;
        this.currentFragIds = viewer.fragIdsSelected;
        if (options.onTaskUpdate)
            this.onTaskUpdate = options.onTaskUpdate;
        if (options.reload)
            this.reload = options.reload;

        runInInjectionContext(this.injector, () => {
            effect(() => {
                const isLoadingMetrics = this.planningStore.isLoadingMetrics()
                const isLoadingTasks = this.planningStore.isLoadingTasks()
                const isLoadingFragments = this.planningStore.isLoadingFragments()
                if (!isLoadingMetrics && !isLoadingTasks && !isLoadingFragments) {

                }
            })

            effect(() => {
                this.fragments = this.planningStore.fragments();
            });

            effect(() => {
                this.tasks = this.planningStore.tasks();
            });

            effect(() => {
                this.currentTask = this.planningStore.currentTask();
                this.currentFragments = this.planningStore.getFragmentsByIds(this.currentTask?.fragments ?? []);
                // this.viewer.fitToView(this.currentFragments.map((f: Fragment) => f.dbId).filter((id: number | undefined): id is number => id !== undefined));
                // this.viewer.select([])
            });

            effect(() => {
                this.selectedMetrics = this.planningStore.selectedMetrics();
                this.buildHTML()
            })

            effect(() => {
                this.metrics = this.planningStore.metrics();
            });

            effect(() => {
                let fragments = this.planningStore.selectedFragments();
                this.onFragmentsSelected(fragments);
            })
        });

        this.init();
    }

    init(): void {
        // the style of the docking panel
        this.container.style.top = "20px";
        this.container.style.left = "20px";
        this.container.style.width = "350px";

        this.container.style.height = "80%";
        this.container.style.overflow = "hidden";
        this.container.style.resize = "none";
        this.container.style.display = 'block';

        let div = document.createElement('div');
        div.classList.add('docking-panel-container-solid-color-a', 'right');
        div.style.padding = '6px 12px 0px';

        div.style.height = "calc(100% - 60px)";
        div.style.overflowY = "auto";
        div.style.overflowX = "hidden";
        div.style.boxSizing = "border-box";

        this.container.appendChild(div);
        this.mainContainer = div;
    }

    onFragmentsSelected(fragments: Fragment[]) {
        if (this.waitForSelection.length && fragments.length == 1) {
            let fragToUpdate: Fragment[] = [];

            this.waitForSelection.forEach((s: string) => {
                let metric: Metric | undefined = this.metrics.find(m => m.id == s);

                if (!metric || !fragments[0]) return;

                let metricIndex = fragments[0].metrics?.findIndex((_m: any) => _m.id == metric.id) ?? -1
                let objectIndex = fragments[0].objects?.findIndex((_m: any) => _m.metric == metric.id) ?? -1

                if (metricIndex == -1 && metric) {
                    if (!fragments[0].metrics)
                        fragments[0].metrics = [];

                    let midDate = ""

                    if (metric.payload.startDate && metric.payload.endDate) {
                        midDate = fromUnixTime(
                            Math.floor((getUnixTime(new Date(metric.payload.startDate)) + getUnixTime(new Date(metric.payload.endDate))) / 2)
                        ).toISOString()
                    }

                    fragments[0].metrics!.push({
                        id: metric.id,
                        startDate: metric.payload.startDate,
                        endDate: metric.payload.endDate,
                        midDate
                    })
                }

                if (objectIndex == -1 && metric) {
                    if (!fragments[0].objects)
                        fragments[0].objects = [];

                    fragments[0].objects!.push({
                        metric: metric.id,
                        name: metric.payload.title,
                        createdDate: metric.payload.endDate,
                        ...metric.payload['endPosition']
                    })
                }

                this.fragments.forEach((f: Fragment) => {
                    let metricIndex = f.metrics?.findIndex((_m: any) => _m.id == metric?.id) ?? -1
                    let objectIndex = f.objects?.findIndex((_m: any) => _m.metric == metric?.id) ?? -1

                    if (metricIndex >= 0 && f.metrics)
                        f.metrics.splice(metricIndex, 1)

                    if (objectIndex >= 0 && f.objects)
                        f.objects.splice(objectIndex, 1)

                    if (metricIndex >= 0 || objectIndex >= 0) {
                        if (!fragToUpdate.find((_f: Fragment) => _f.id == f.id))
                            fragToUpdate.push(f)
                    }
                })
            })

            if (fragments[0])
                fragToUpdate.push(fragments[0])

            fragToUpdate.forEach((f: Fragment) => {
                let sub = this.planningService.updateFragment(f).subscribe((res: any) => {
                    sub.unsubscribe()
                })
            })

            this.buildHTML();
        } else {
            this.fragments = fragments;
            this.buildHTML();
        }

        this.waitForSelection = [];
    }

    render(): void {
        this.taskListElem = document.getElementById('task-list');
    }

    bindEvents(): void {
        let isolateBtn = document.getElementById("isolate-btn");
        if (isolateBtn) {
            isolateBtn.removeEventListener("click", (evt) => this.isolate());
            isolateBtn.addEventListener("click", (evt) => this.isolate());
        }

        const metricsLinkBtn = document.getElementById('metrics-link-btn');
        if (metricsLinkBtn) metricsLinkBtn.addEventListener('click', () => {
            let metricCheck = document.getElementsByClassName("metric-checkbox");
            this.waitForSelection = [];

            for (let i = 0; i < metricCheck.length; i++) {
                let b = metricCheck[i] as HTMLInputElement;
                if (b?.checked && b.dataset?.['metric']) {
                    this.waitForSelection.push(b.dataset['metric'])
                }
            }
        });

        let pictureBtns = document.getElementsByClassName("picture-btn");
        for (let i = 0; i < pictureBtns.length; i++) {
            let b = pictureBtns[i];

            if (b)
                b.addEventListener("click", (event: any) => {
                    let date = event.target?.dataset?.name;
                    let tracker = event.target?.dataset?.tracker;
                    let metricId = event.target?.dataset?.metric;

                    if (metricId !== "undefined") {
                        let metric = this.selectedMetrics.find(m => m.id == metricId)
                        this.planningStore.selectMetrics(metric ? [metric] : [])
                    } else {
                        let metric = this.selectedMetrics.filter(m => m.payload.startDate && m.payload.endDate && isWithinInterval(date, { start: m.payload.startDate, end: m.payload.endDate }))
                        this.planningStore.selectMetrics(metric)
                    }

                    this.getPicture({ createdDate: date, tracker })
                })
        }

        let metricBtns = document.getElementsByClassName("metric-link-btn");

        for (let i = 0; i < metricBtns.length; i++) {
            let b = metricBtns[i];

            if (!b) continue;

            b.addEventListener("click", (evt: any) => {
                this.waitForSelection = [evt.target.dataset.metric];
            })
        }

        if (this.objectStateElem) {
            this.objectStateElem.removeEventListener('change', (evt) => this.changePlanningState(evt))
        }

        if (this.objectDateElem) {
            this.objectDateElem.removeEventListener('change', (evt) => this.changePlanningDate(evt))
        }

        this.objectStateElem = document.getElementById('object-state');
        if (this.objectStateElem)
            this.objectStateElem.addEventListener('change', (evt) => this.changePlanningState(evt));

        if (this.objectTypeElem) {
            this.objectTypeElem.removeEventListener('change', (evt) => this.changeFragInfo("type", evt))
        }

        this.objectTypeElem = document.getElementById('object-type');
        if (this.objectTypeElem)
            this.objectTypeElem.addEventListener('change', (evt) => this.changeFragInfo("type", evt));

        if (this.objectLevelElem)
            this.objectLevelElem.removeEventListener('change', (evt) => this.changeFragInfo("level", evt))

        this.objectLevelElem = document.getElementById('object-level');
        if (this.objectLevelElem)
            this.objectLevelElem.addEventListener('change', (evt) => this.changeFragInfo("level", evt));

        if (this.objectZoneElem)
            this.objectZoneElem.removeEventListener('change', (evt) => this.changeFragInfo("levelZone", evt))

        this.objectZoneElem = document.getElementById('object-zone');
        if (this.objectZoneElem)
            this.objectZoneElem.addEventListener('change', (evt) => this.changeFragInfo("levelZone", evt));

        this.objectDateElem = document.getElementById('object-date');
        if (this.objectDateElem)
            this.objectDateElem.addEventListener('blur', (evt) => this.changePlanningDate(evt));

        const unlinkTaskBtn = document.getElementById('unlink-task-btn');
        if (unlinkTaskBtn) unlinkTaskBtn.addEventListener('click', () => this.unlinkTask());
    }

    buildHTML() {
        this.loadAndRenderHtml(this.mainContainer as HTMLDivElement);
    }

    formatTiming(value: number): string {
        let day, hour, minute, second, mod = value;
        let formatted = "";

        day = Math.floor(value / (3600 * 24))
        mod = value % (3600 * 24)
        formatted = day + "d ";
        hour = Math.floor(mod / 3600)
        formatted += hour + "h ";
        mod = mod % 3600;

        minute = Math.floor(mod / 60);
        mod = mod % 60;
        formatted += Math.floor(minute) + "m ";

        second = mod;
        formatted += Math.floor(second) + "s";

        return formatted;
    }

    updateFragment(fragment: Fragment): void {

    }

    isolate(): void {
        let dbIds = this.fragments.map((f: Fragment) => f.dbId)
        this.viewer.fitToView(dbIds, null, true);
        this.viewer.impl.visibilityManager.isolate(dbIds, this.viewer.model)
    }

    deleteObjects(): void {
        this.fragments.forEach((f: Fragment) => {

            f.objects = [];

            this.planningService.updateFragment(f).subscribe((res: any) => {
                this.buildHTML();
            })
        })

        this.planningStore.selectFragments(this.fragments)
    }

    changePlanningDate(evt: Event): void {
        const target = evt.target as HTMLInputElement;
        let date = target.value;
        this.fragments.forEach((f: Fragment) => {
            f.doneDate = new Date(date).toISOString();
            this.planningService.updateFragment(f).subscribe((res: any) => {
                this.buildHTML();
            })
        })
    }

    changeFragInfo(type: string, evt: Event): void {
        const target = evt.target as HTMLInputElement;
        let val = target.value;
        // if (val == "null" || val == "---") val = null;
        if (val == "null" || val == "---") return;

        this.fragments.forEach((f: Fragment) => {
            let shouldUpdate = false;
            if (type === 'type' && val != f.type) {
                f.type = val;
                shouldUpdate = true;
            } else if (type === 'level' && val != f.level) {
                f.level = val;
                shouldUpdate = true;
            } else if (type === 'levelZone' && val != f.levelZone) {
                f.levelZone = val;
                shouldUpdate = true;
            }

            if (shouldUpdate) {
                this.planningService.updateFragment(f).subscribe((res: any) => {
                    this.buildHTML();
                })
            }
        })

        this.planningStore.selectFragments(this.fragments)
    }

    changeFragLevel(evt: Event): void {
        const target = evt.target as HTMLInputElement;
        let level = target.value;
        if (level == "null" || level == "---") return;

        this.fragments.forEach((f: Fragment) => {

            if (level != f.level) {
                f.level = level;

                this.planningService.updateFragment(f).subscribe((res: any) => {
                    this.buildHTML();
                })
            }
        })

        this.planningStore.selectFragments(this.fragments)
    }

    changeFragType(evt: Event): void {
        const target = evt.target as HTMLInputElement;
        let type = target.value;
        if (type == "null" || type == "---") return;

        this.fragments.forEach((f: Fragment) => {

            if (type != f.type) {
                f.type = type;

                this.planningService.updateFragment(f).subscribe((res: any) => {
                    this.buildHTML();
                })
            }
        })

        this.planningStore.selectFragments(this.fragments)
    }

    changePlanningState(evt: Event): void {
        const target = evt.target as HTMLInputElement;
        let status = target.value;
        if (status == "null" || status == "---") return;

        this.fragments.forEach(f => {

            if (status != f.status) {
                f.status = status;
                if (status == "todo") {
                    f.volumeProgress = 0;
                    f.objects = [];
                }
                if (status == "done") {
                    f.volumeProgress = f.volume;
                }

                this.planningService.updateFragment(f).subscribe((res: any) => {
                    this.buildHTML();
                })
            }
        })

        this.tasks.forEach((task: PlanningTask) => {
            task.volume = 0;
            task.volumeProgress = 0;

            this.fragments.forEach((f: Fragment) => {
                let index = task.fragments?.indexOf(f.id) ?? -1
                if (index >= 0) {
                    task.volume += f.volume || 0;
                    task.volumeProgress += f.volumeProgress || 0;
                }
            })

            task.progress = task.volumeProgress / task.volume;
            this.planningStore.updateTask(task);

            this.planningService.updateTask(task as PutTask).subscribe((res: any) => { }, (err: any) => console.error(err))
        })

        this.planningStore.selectFragments(this.fragments)
    }

    unlinkTask(): void {
        this.tasks.forEach((task: PlanningTask) => {
            // return;
            this.fragments.forEach((f: Fragment) => {
                let index = task.fragments?.indexOf(f.id) ?? -1
                if (index >= 0) {
                    (task.fragments ??= []).splice(index, 1);
                }
                if (f.dbId !== undefined) {
                    let dbIndex = task.fragmentDbIds?.indexOf(f.dbId) ?? -1
                    if (dbIndex >= 0) {
                        (task.fragmentDbIds ??= []).splice(dbIndex, 1);
                    }
                }
            })

            this.planningStore.updateTask(task);
            this.planningService.updateTask(task as PutTask).subscribe((res: any) => { }, (err: any) => console.error(err))
            this.mainContainer.innerHTML = '';

            this.mainContainer.innerHTML = '';
            this.buildHTML();

        })
        this.planningStore.selectTasks([]);
    }

    getPicture(query: { createdDate: string; tracker?: string }): void {
        this.planningService.getFragmentPicture(query).subscribe((res: any) => {
            let selectedFrag = this.selectedFragments;
            let isSelected = selectedFrag.find((f: Fragment) => this.currentFragIds.indexOf(f.dbId as number) >= 0)

            if (isSelected) {
                let imgCont = document.getElementById('fragment-picture') as HTMLImageElement;

                if (!imgCont) return;

                let imgTitle = document.getElementById('fragment-title') as HTMLElement;
                imgCont.src = res.url;

                (imgCont as any).data = {
                    attachment: res
                }

                imgCont.style.display = "block";
                imgTitle.style.display = "block";
            }
        })
    }

    async loadAndRenderHtml(div: HTMLDivElement) {
        const template = await this.loadHtmlTemplate('viewer/planning/planning-extension/planning-extension.html');
        const selectedFragments = this.planningStore.selectedFragments();
        const allFragments = this.planningStore.fragments();
        const isGlobalMode = !selectedFragments.length;
        const fragmentsForView = isGlobalMode ? allFragments : selectedFragments;
        const objectCount = fragmentsForView.length;

        if (isGlobalMode) {
            this.objectNameText = this.translate.instant('planning.planning_overview');
            this.objectdbId = `${objectCount} objects`;
        } else {
            const updatedFrags = [...fragmentsForView].sort(
                (a, b) => new Date(a.lastUpdate || 0).getTime() - new Date(b.lastUpdate || 0).getTime()
            );

            const first = updatedFrags[0] ?? fragmentsForView[0];
            this.objectNameText = objectCount > 1 ? `${objectCount} objects selected` : (first?.name || 'Unknown');
            this.objectdbId = objectCount > 1 ? `${objectCount} objects selected` : (first?.dbId?.toString() || 'Unknown');
        }

        let totalDuration = 0;
        let volume = 0;
        let volumeProgress = 0;

        fragmentsForView.forEach(f => {
            volume += f.volume || 0;
            volumeProgress += f.volumeProgress || 0;
            (f.objects || []).forEach(o => {
                if (o.duration) totalDuration += +o.duration;
            });
        });

        const volumeBarWidth = volume ? (volumeProgress / volume) * 100 : 0;
        const linkedTasks = isGlobalMode ? this.tasks : this.planningStore.getFragmentTask(fragmentsForView.map(f => f.id));
        const unlinkLabel = this.translate.instant('planning.unlink');

        const linkedTasksHtml = linkedTasks.length ? linkedTasks.map(task => `
          <li>
            ${task.text}
            <button class="unlink-task-btn" data-task-id="${task.id || ''}" title="${unlinkLabel}" aria-label="${unlinkLabel}" type="button">
              <span class="material-icons" aria-hidden="true">link_off</span>
            </button>
          </li>
        `).join('') : `<li>${this.translate.instant('planning.none')}</li>`;

        const toDateInput = (d?: string | number) => {
            if (!d) return '';
            const dt = new Date(d);
            return Number.isNaN(dt.getTime()) ? '' : dt.toISOString().slice(0, 10);
        };

        const buildOptions = (items: Array<{ label: string; value: string }>, selected: string) =>
            items.map(i => `<option value="${i.value}" ${i.value === selected ? 'selected' : ''}>${i.label}</option>`).join('');

        let isTodo = false;
        let isInProgress = false;
        let isDone = false;
        let type = '';
        let level = '';
        let levelZone = '';
        let doneDate: string | number | undefined;

        fragmentsForView.forEach(f => {
            if (f.status === 'todo' || !f.status) isTodo = true;
            if (f.status === 'progress') isInProgress = true;
            if (f.status === 'done') isDone = true;

            if (type !== 'null') type = f.type ? f.type : 'null';
            if (level !== 'null') level = f.level ? f.level : 'null';
            if (levelZone !== 'null') levelZone = f.levelZone ? f.levelZone : 'null';

            if (f.doneDate) {
                if (!doneDate || new Date(f.doneDate) > new Date(doneDate)) doneDate = f.doneDate;
            }
        });

        let state = '';

        if (isDone && !isInProgress && !isTodo) state = 'done';
        if (isTodo && !isInProgress) state = 'todo';
        if (isInProgress || (isDone && isTodo)) state = 'progress';

        const stateOptionsHtml = buildOptions([
            { label: '---', value: '' },
            { label: this.translate.instant('planning.done'), value: 'done' },
            { label: this.translate.instant('planning.in_progress'), value: 'progress' },
            { label: this.translate.instant('planning.to_do'), value: 'todo' },
        ], state);

        const typeOptionsHtml = buildOptions([
            { label: '---', value: '' },
            { label: this.translate.instant('planning.wallCEP'), value: 'wall' },
            { label: this.translate.instant('planning.prefabricated_wall'), value: 'prefabricatedWall' },
            { label: this.translate.instant('planning.floor'), value: 'floor' },
            { label: this.translate.instant('planning.beam'), value: 'beam' },
            { label: this.translate.instant('planning.columnCEP'), value: 'column' },
            { label: this.translate.instant('planning.foundation'), value: 'foundation' },
            { label: this.translate.instant('planning.stair'), value: 'stair' },
        ], type);

        const levelOptionsHtml = buildOptions([
            { label: '---', value: 'null' },
            ...((this.model.levels || []).map(l => ({ label: l.name || '', value: l.name || '' })))
        ], level || 'null');

        const zoneOptionsHtml = buildOptions([
            { label: '---', value: 'null' },
            ...((this.model.zones || []).map(z => ({ label: z, value: z })))
        ], levelZone || 'null');

        const variables: Record<string, string | number> = {
            object_name: this.objectNameText,
            object_id: this.objectdbId,
            linked_tasks_html: linkedTasksHtml,
            volume_progress_text: `${volumeProgress.toFixed(2)}/${volume.toFixed(2)}m³`,
            volume_progress_width: volumeBarWidth.toFixed(2),
            duration_text: this.formatTiming(totalDuration),
            planning_linked_task: this.translate.instant('planning.linked_task'),
            planning_none: this.translate.instant('planning.none'),
            planning_planning_status: this.translate.instant('planning.planning_status'),
            planning_done: this.translate.instant('planning.done'),
            planning_in_progress: this.translate.instant('planning.in_progress'),
            planning_to_do: this.translate.instant('planning.to_do'),
            planning_fragment_type: this.translate.instant('planning.fragment_type'),
            planning_fragment_level: this.translate.instant('planning.fragment_level'),
            planning_fragment_zone: this.translate.instant('planning.fragment_zone'),
            planning_planning_date: this.translate.instant('planning.planning_date'),
            planning_volume_progress: this.translate.instant('planning.volume_progress'),
            planning_duration: this.translate.instant('planning.duration'),
            planning_isolate: this.translate.instant('planning.isolate'),
            planning_linked_image: this.translate.instant('planning.linked_image'),
            objects_html: '',
            state_options_html: stateOptionsHtml,
            type_options_html: typeOptionsHtml,
            level_options_html: levelOptionsHtml,
            zone_options_html: zoneOptionsHtml,
            done_date: toDateInput(doneDate)
        };

        div.innerHTML = this.renderTemplate(template, variables);

        const volumeBar = div.querySelector('#volume-progress-bar') as HTMLElement | null;
        if (volumeBar) {
            volumeBar.style.width = `${volumeBarWidth.toFixed(2)}%`;
        }

        this.bindEvents();
    }

    async loadHtmlTemplate(path: string): Promise<string> {
        const response = await fetch(path);
        return await response.text();
    }

    renderTemplate(template: string, variables: Record<string, string | number>) {
        return template.replace(/{{(.*?)}}/g, (_, key) => String(variables[key.trim()] ?? ''));
    }
}